import React from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { I18nProvider } from "@/context/I18nContext";
import { ConsentProvider } from "@/context/ConsentContext";
import SiteLayout from "@/components/SiteLayout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";

const SUPPORTED = ["fr", "en"];

function LangRoutes() {
  const { lang } = useParams();
  if (!SUPPORTED.includes(lang)) {
    return <Navigate to="/fr" replace />;
  }
  return (
    <I18nProvider lang={lang}>
      <SiteLayout />
    </I18nProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ConsentProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/fr" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route path="/:lang" element={<LangRoutes />}>
            <Route index element={<Home />} />
            <Route path="privacy" element={<LegalPage pageKey="privacy" />} />
            <Route path="cookies" element={<LegalPage pageKey="cookies" />} />
            <Route path="terms" element={<LegalPage pageKey="terms" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="*" element={<Navigate to="/fr" replace />} />
        </Routes>
      </ConsentProvider>
    </BrowserRouter>
  );
}

export default App;
